const handleDeleteGroupModalEquipService = {
  confirm: '¿Realmente desea eliminar la sección?',
  title: 'ELIMINAR SECCIÓN DE LA CHECKLIST'
};

export default handleDeleteGroupModalEquipService;
